module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesCool.7fc379c.jpg";